import React from 'react';
import Avatar from 'boring-avatars';

export const DEFAULT_PALETTE = ['#0e7490', '#155e75', '#164e63', '#06b6d4', '#67e8f9'];

export const PALETTES = [
  ['#0e7490', '#155e75', '#164e63', '#06b6d4', '#67e8f9'], // cyan (default)
  ['#7c3aed', '#5b21b6', '#4c1d95', '#a78bfa', '#ddd6fe'], // violet
  ['#b45309', '#92400e', '#78350f', '#fbbf24', '#fde68a'], // amber
  ['#065f46', '#064e3b', '#022c22', '#34d399', '#a7f3d0'], // emerald
  ['#be123c', '#9f1239', '#881337', '#fb7185', '#fecdd3'], // rose
  ['#0369a1', '#075985', '#0c4a6e', '#38bdf8', '#bae6fd'], // sky
  ['#6d28d9', '#1d4ed8', '#0f172a', '#a855f7', '#60a5fa'], // purple-blue
  ['#b91c1c', '#7c3aed', '#1e3a5f', '#f87171', '#c4b5fd'], // red-violet
];

// Parses an encoded avatar_seed string ("shape-part|paletteIndex") into its components.
export function parseSeed(seed) {
  if (!seed) return { avatarSeed: null, paletteIndex: 0 };
  const parts = seed.split('|');
  const paletteIndex = parts.length > 1 ? parseInt(parts[1], 10) || 0 : 0;
  return { avatarSeed: parts[0], paletteIndex };
}

/**
 * Deterministic agent avatar.
 *
 * Uses boring-avatars for in-app rendering (no network round-trip).
 * Pass `src` to render a custom uploaded image instead (future iteration).
 *
 * Props:
 *   name    - agent name; used as fallback seed when `seed` is not provided
 *   seed    - explicit seed string (agent.avatar_seed); overrides name
 *   colors  - 5-color palette array; defaults to DEFAULT_PALETTE
 *   size    - pixel size (default 40)
 *   src     - optional custom image URL; if set, renders an <img> instead
 */
export const AgentAvatar = ({ name, seed = null, colors = DEFAULT_PALETTE, size = 40, src = null }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        width={size}
        height={size}
        className="rounded-full object-cover flex-shrink-0"
      />
    );
  }
  return (
    <Avatar
      size={size}
      name={seed || name || '?'}
      variant="beam"
      colors={colors}
    />
  );
};
